import {appLocalStorage, appSessionStorage} from '../services';
import {email as emailRule} from 'vee-validate/dist/rules';

const initialState = () => {
  return {
    currentStep: 1,
    showLoginForm: false,
    isBusinessAccount: false,
    customerEmail: appLocalStorage.getItem('checkout-customer-email', ''),
    extensionAttributes: appLocalStorage.getItem('checkout-extension-attributes', {}),
    newsletterSubscribe: appLocalStorage.getItem('checkout-newsletter-subscription', false),
  };
};

const getters = {
  currentStep: (state) => state.currentStep,
  customerEmail: (state) => state.customerEmail,
  isBusinessAccount: (state) => state.isBusinessAccount,
  showLoginForm: (state) => state.showLoginForm,
  getExtensionAttributes: (state) => state.extensionAttributes,
};

const mutations = {
  TOGGLE_LOGIN_FORM(state) {
    state.showLoginForm = !state.showLoginForm;
  },
  SET_CURRENT_STEP(state, currentStep) {
    state.currentStep = currentStep;
  },
  SET_CUSTOMER_EMAIL(state, customerEmail) {
    const normalizedCustomerEmail = customerEmail || '';
    state.customerEmail = normalizedCustomerEmail;
    appLocalStorage.setItem('checkout-customer-email', normalizedCustomerEmail);
  },
  SET_IS_BUSINESS_ACCOUNT(state, isBusinessAccount) {
    state.isBusinessAccount = isBusinessAccount;
    appLocalStorage.setItem('customer-is-b2b', isBusinessAccount);
  },
  SET_NEWSLETTER_SUBSCRIBE(state, status) {
    state.newsletterSubscribe = status;
    appLocalStorage.setItem('checkout-newsletter-subscription', status);
  },
  ADD_EXTENSION_ATTRIBUTE(state, extensionAttribute) {
    state.extensionAttributes = {
      ...state.extensionAttributes,
      ...extensionAttribute,
    };
    appLocalStorage.setItem('checkout-extension-attributes', state.extensionAttributes);
  },
  REMOVE_EXTENSION_ATTRIBUTE(state, extensionAttribute) {
    if (state.extensionAttributes.hasOwnProperty(extensionAttribute)) {
      delete state.extensionAttributes[extensionAttribute];
    }
    appLocalStorage.setItem('checkout-extension-attributes', state.extensionAttributes);
  },
  CLEAR_EXTENSION_ATTRIBUTE(state) {
    state.extensionAttributes = {};
    appLocalStorage.removeItem('checkout-extension-attributes');
  },
};

const actions = {
  async checkCustomerEmail({ state, commit, rootState }, customerEmail) {
    try {
      return await this.$solarClient.post(`/api/checkout/customers/isEmailAvailable`, {
        customerEmail: customerEmail,
      });
    } catch (e) {
      return false;
    }
  },
  async addExtensionAttribute({ commit }, extensionAttribute) {
    commit('ADD_EXTENSION_ATTRIBUTE', extensionAttribute);
  },
  async gotoStep({ commit }, step) {
    commit('SET_CURRENT_STEP', step);
  },
  setNewsletterSubscribe({ commit, dispatch }, status) {
    commit('SET_NEWSLETTER_SUBSCRIBE', status);
    commit('ADD_EXTENSION_ATTRIBUTE', {'newsletter_subscribe': status});
    dispatch('subscribeKlaviyoNewsletter');
  },
  async saveGuestEmail({ state }) {
    if (!emailRule.validate(state.customerEmail)) {
      return;
    }

    if (window['klaviyo'] && window.Config['klaviyo_public_key']) {
      window['klaviyo'].identify({ email: state.customerEmail });
    }

    try {
      await this.$solarClient.post('/api/custom/checkout/guest-email', { email: state.customerEmail });
    } catch (e) {
      //
    }
  },
  async subscribeKlaviyoNewsletter({ state, rootGetters }) {
    const companyId = window.Config['klaviyo_public_key'];
    const listId = window.Config['klaviyo_newsletter_list_id'];
    const email = state.customerEmail;

    if (
      !state.newsletterSubscribe
      || !companyId
      || !listId
      || !emailRule.validate(email)
      || appLocalStorage.getItem('checkout-klaviyo-subscribed-email', '') === email
    ) {
      return;
    }

    try {
      const response = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${companyId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2025-01-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Checkout',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email,
                    first_name: rootGetters['CheckoutAddress/billingAddress']?.['firstname'] || undefined,
                    subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
                  },
                },
              },
            },
            relationships: { list: { data: { type: 'list', id: listId } } },
          },
        }),
      });

      if (response.ok) {
        appLocalStorage.setItem('checkout-klaviyo-subscribed-email', email);
      }
    } catch (e) {
      //
    }
  },
  toggleLoginForm({ commit }) {
    commit('TOGGLE_LOGIN_FORM');
  },
};

const state = initialState();

const CheckoutGlobal = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default CheckoutGlobal;
